import { Link } from "react-router-dom";
import Button from "../Button";
import { closesvg } from "../../assets/svg/svgimages";
import linkIng from "../../assets/images/menu-link-icon.svg";

import styles from "./Header.module.css";
import Modal from "../Modal/Modal";
import { useState, useRef, useEffect } from "react";
import ContacUs from "../ContacUs/ContacUs";

const HeaderLinks = ({ isMenuOpen, handleCloseMenu }) => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isMenuOpen &&
        menuRef.current &&
        !menuRef.current.contains(event.target)
      ) {
        handleCloseMenu();
      }
    };

    if (isMenuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
      document.addEventListener("touchstart", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, [isMenuOpen, handleCloseMenu]);

  const handleOpen = () => {
    setIsOpen(true);
  };

  const modalClose = () => {
    setIsOpen(false);
  };

  return (
    <div className={`${styles.linkslist} ${isMenuOpen ? styles.open : ""}`}>
      <div ref={menuRef} className={styles.menuInner}>
        <div className={styles.closebtn}>
          <button onClick={handleCloseMenu}>{closesvg}</button>
        </div>
        <h2 className={`h2-bold ${styles.menuTitle}`}>Menu</h2>
        <ul>
          <li>
            <Link to="library" onClick={handleCloseMenu}>
              {" "}
              <img src={linkIng} alt="btn-icon" />
              Library
            </Link>
          </li>
          <li>
            <Link to="/how-it-works" onClick={handleCloseMenu}>
              {" "}
              <img src={linkIng} alt="btn-icon" />
              How it works
            </Link>
          </li>
          <li>
            <Link to="/affiliate-program" onClick={handleCloseMenu}>
              {" "}
              <img src={linkIng} alt="btn-icon" />
              Affiliate program
            </Link>
          </li>
          <li>
            <Link to="/tutorials" onClick={handleCloseMenu}>
              {" "}
              <img src={linkIng} alt="btn-icon" />
              Tutorials
            </Link>
          </li>
          <li>
            <Link to="/faq" onClick={handleCloseMenu}>
              {" "}
              <img src={linkIng} alt="btn-icon" />
              FAQ
            </Link>
          </li>
          <li>
            <button
              type="button"
              className={styles.contactUs}
              onClick={handleOpen}
            >
              {" "}
              <img className={styles.img} src={linkIng} alt="btn-icon" />
              Contact Us
            </button>
          </li>
        </ul>
      </div>
      <Modal isOpen={isOpen} onClose={modalClose}>
        <ContacUs />
      </Modal>
    </div>
  );
};

export default HeaderLinks;
